<template>
  <div class="home">
    <div class="page" v-show="page === 1"><img src="https://yunyingcdn.thecover.cn/o_1eqro8tj1psk6ng899c8bhe9.png" class="page1 animate__animated animate__fadeIn" alt="" @click="page = 2"></div>
    <div class="page" v-show="page === 2">
      <img src="https://yunyingcdn.thecover.cn/o_1eqrod6pc37b1flp1rngu16f33t.png" class="page2-t animate__animated animate__fadeIn" alt="">
      <img src="https://yunyingcdn.thecover.cn/o_1eqrochqge62to11f7n6ijdv7o.png" class="page2-d animate__animated animate__fadeIn animate__delay-1s" alt="">
      <img src="https://yunyingcdn.thecover.cn/o_1eqrobtff1j9i1f101vqu1k5ve4uj.png" class="page2-r animate__animated animate__fadeInUp animate__delay-3s" alt="">
      <img src="https://yunyingcdn.thecover.cn/o_1eqrodmoq1919167nj6tckmif312.png" class="page2-b animate__animated animate__fadeIn animate__delay-4s" alt="" @click="page = 3">
    </div>
    <div class="page page-3" v-show="page === 3">
      <div class="page3-p">{{ answer + 1 }}/8</div>
      <div class="page3-t animate__animated animate__fadeInDown">{{ answerData[answer].title }}</div>
      <div class="page3-a animate__animated" :class="(option[answer] === index ? 'hover' : '') + ' ' + (index % 2 ? 'animate__fadeInRight' : 'animate__fadeInLeft')" v-for="(item, index) in answerData[answer].option" :key="index" @click="handleAnswer(index)">
        <span>{{ index === 0 ? 'A' : (index === 1 ? 'B' : 'C') }}</span>
        <div>{{ item }}</div>
      </div>
      <img src="../assets/img/p_next.png" class="page-next" alt="" v-show="answer" @click="onPrev">
      <img src="../assets/img/p_logo.png" class="page-logo" alt="">
    </div>
    <div class="result" v-show="page === 4">
      <div class="page4 animate__animated animate__fadeIn">
        <div class="page4-d">
          {{ keyData[key].intro }}
          <span>{{ keyData[key].desc }}</span>
        </div>
        <img :src="keyData[key].img" class="page4-p animate__animated animate__fadeInBottomLeft" alt="">
        <img :src="keyData[key].title" class="page4-t animate__animated animate__fadeInDown" alt="">
      </div>
      <div class="page4-b animate__animated animate__fadeInUp animate__delay-1s">
        <img src="../assets/img/p_qu.png" alt="" @click="onToOffline">
        <img src="../assets/img/p_share.png" alt="" @click="isShare = true">
      </div>
      <div class="page-r animate__animated animate__fadeInUp animate__delay-2s" @click="handleRestart">重新测试</div>
    </div>

    <div class="ad animate__animated animate__bounceIn" v-show="isShowAd">
      <img class="ad-img" src="https://yunyingcdn.thecover.cn/o_1eqp7kg5a17p3d7r1tm81bfu1dfq9.jpg" alt="" @click="isShowAd = false">
      <img class="restart animate__animated animate__fadeIn animate__delay-1s" src="../assets/img/p_restart.png" alt="" @click="handleRestart">
    </div>

    <div class="animate__animated animate__fadeIn share" v-show="isShare" @click="isShare = false">
      <img :src="keyData[key].share" style="width: 100%; height: 100%;" alt="">
      <img :src="keyData[key].share" class="share-opacity" alt="">
      <img src="https://yunyingcdn.thecover.cn/o_1eqrnla6j1ijsq9o1hk5105j13rv9.png" class="share-btn" alt="" srcset="">
    </div>
  </div>
</template>

<script>
import CONFIG from "@/utils/config";
import COVERAPP from "@/utils/COVERAPP";
import COVER from "@/utils/COVER";

import { mapState, mapActions } from "vuex";

const answerData = [
  {
    title: '你认为最有可能是什么原因，导致你穿越进了《山海经》？',
    option: [
      '在古玩市场淘到了一本奇怪的《山海经》',
      '朋友神秘地让我低声念三遍“山海经”',
      '去逛了一个叫“鲸梦奇缘·神隐山海经”的光影艺术展会'
    ],
  },
  {
    title: '进入《山海经》后，你最想先去哪里？',
    option: [
      '没有死亡的永生之国',
      '没有烦恼的无忧之国',
      '没有谎言的真实之国'
    ],
  },
  {
    title: '路上一只会说话的九尾仙狐请你帮忙，你觉得它需要你帮助什么？',
    option: [
      '九尾狐不小心爱上了人类，请你想办法成全',
      '九尾狐正在变幻形态，向你请教人类喜欢的样貌',
      '九尾狐计划去参加凤皇的庆典，请教你送什么礼物'
    ],
  },
  {
    title: '帮了九尾狐的大忙，你们成为了好友，它请你前往家乡青丘做客，你会？',
    option: [
      '九尾狐是祥瑞神兽，想去学习一些实用的法术',
      '去看看是不是真的有“三生三世十里桃林”',
      '虽然很想去但时间有限，还是赶紧去找其他神兽玩耍吧'
    ],
  },
  {
    title: '天公不作美，突然下起了雨，你认为《山海经》中的雨是什么样的？',
    option: [
      '有各种奇妙功效的仙草',
      '五彩斑斓但却可以食用的石头',
      '和现实中的雨看上去没有区别但实际很难说'
    ],
  },
  {
    title: '你来到一处大树下避雨，却突然发现大树不那么简单，它是？',
    option: [
      '能登天的神树',
      '太阳居住的神树',
      '能解答任何问题的超级树洞'
    ],
  },
  {
    title: '在《山海经》的世界里，你认为自己遇到的最大困难是？',
    option: [
      '无法判断神兽的能力',
      '日不升月不沉，不能知晓时间',
      '找不到回到现实世界的方法'
    ],
  },
  {
    title: '旅行即将结束，送你返回的神仙想赠送你一只神兽，你认为是？',
    option: [
      '美艳万千的九尾神狐',
      '带来爱情的比翼鸟',
      '浴火重生的凤皇'
    ],
  }
];

const keyData = [
  {
    img: 'https://yunyingcdn.thecover.cn/o_1eqrmga9kg51o2m151l5sfta9.png',
    title: 'https://yunyingcdn.thecover.cn/o_1eqrmko7d1qf8kuh1m5qb5tlqh.png',
    share: 'https://yunyingcdn.thecover.cn/o_1ere2c52tg6h9hv6lbupodhai.jpg',
    intro: '你本是王母的信使青鸾神鸟，后成为三界六道往来的接引使者。你性格温顺、善解人意，稳重大方，优雅中带着高贵，是最善解人意的心灵引领者。你总能在人群中起到调和的作用。',
    desc: '出处：有鸟焉，其状如翟而五采文，名曰鸾鸟，见则天下安宁——《山海经》',
  },
  {
    img: 'https://yunyingcdn.thecover.cn/o_1eqrmgqh61trukj1167i5nq1fa5e.png',
    title: 'https://yunyingcdn.thecover.cn/o_1eqrmko7eb1h1djpv1esbpmhi.png',
    share: 'https://yunyingcdn.thecover.cn/o_1ere2c52trse13h61j6crju2puj.jpg',
    intro: '你是掌管天帝出入通道的神兽陆吾，看似对所有事情漠不关心，懒懒散散，实在很有责任感。你善于提出意见，领导人群，给出妥善的解决方案，偶尔流露出的掌控欲也使你焦灼不安。',
    desc: '出处：其神状虎身而九尾，人面而虎爪;是神也，司天之九部及帝之囿时——《山海经》',
  },
  {
    img: 'https://yunyingcdn.thecover.cn/o_1eqrmh067cd01j912ko134bgmgp.png',
    title: 'https://yunyingcdn.thecover.cn/o_1eqrmko7e1ghe1e7r59r1sklsq1j.png',
    share: 'https://yunyingcdn.thecover.cn/o_1ere2c52t84m9ql1q4ohhcidgk.jpg',
    intro: '你是为爱生为爱死的比翼神鸟，你向往最浪漫炽烈的爱情。尽管常被朋友称为“恋爱脑”，也无碍你对感情的执着。虽然感性，但你却常常能体察周围人的情绪，也是忠诚的化身。',
    desc: '出处：崇吾之山有鸟焉，其状如凫，而一翼一目，相得乃飞，名曰蛮蛮，见则天下大水——《山海经》',
  },
  {
    img: 'https://yunyingcdn.thecover.cn/o_1eqrmh067ttd165t18sunai8fbq.png',
    title: 'https://yunyingcdn.thecover.cn/o_1eqrmko7e1t2i1kt1i32kgsvs4k.png',
    share: 'https://yunyingcdn.thecover.cn/o_1ere2c52t10en1eqiqtofea1umsl.jpg',
    intro: '你是百鸟之王凤皇，是天地最初也是最后的火种。你有点腹黑，喜欢新鲜感，追求刺激，但你也是华贵、伟岸、进取的象征，是值得信赖的朋友。',
    desc: '出处：有鸟焉，其状如鸡，五采而文，名曰凤皇。——《山海经》',
  },
  {
    img: 'https://yunyingcdn.thecover.cn/o_1eqrmh0671iqap5g1k7u1qrc88hr.png',
    title: 'https://yunyingcdn.thecover.cn/o_1eqrmko7e3pk1lsg105c2fe1mi9l.png',
    share: 'https://yunyingcdn.thecover.cn/o_1ere2c52t4k3383aeg1care6am.jpg',
    intro: '你是有着白尾、形如灵猫的神兽朏朏，是无忧的精灵。你性格开朗、聪明机敏，常常展示出无忧无虑的一面，使人忘记烦恼，因此总能吸引到志同道合的朋友。',
    desc: '出处：有兽焉，其状如狸，而白尾有鬣，名曰’朏朏’，养之可以已忧——《山海经》',
  },
  {
    img: 'https://yunyingcdn.thecover.cn/o_1eqrmh0677v113bma8n1mq8quqs.png',
    title: 'https://yunyingcdn.thecover.cn/o_1eqrmko7enp51h611kni1n1i267m.png',
    share: 'https://yunyingcdn.thecover.cn/o_1ere2c52t13k61qjs66c6v9sg2n.jpg',
    intro: '你是象征着生命之力的春神句芒。你很有爱心，关注世间万物，虽然常常给人多管闲事的感觉，但依然热情、永不言败，是周围人信赖的男神女神。',
    desc: '东方句芒，鸟身人面，乘两龙——《山海经》',
  },
  {
    img: 'https://yunyingcdn.thecover.cn/o_1eqrvsdm0132adgacln15odm969.png',
    title: 'https://yunyingcdn.thecover.cn/o_1eqrmko7e1qi31vb412kv101s73n.png',
    share: 'https://yunyingcdn.thecover.cn/o_1ere2c52t15941hd71mer53f1jvpo.jpg',
    intro: '你是象征着自然无为的神兽犀兕，也是绝对的专注者。你为人正直，待人和善，很会换位思考，是最有分寸的朋友。',
    desc: '出处：兕在舜葬东，湘水南。其状如牛，苍黑，一角。——《山海经》',
  },
  {
    img: 'https://yunyingcdn.thecover.cn/o_1eqrmh0671t2sq5q1asqpmb1698u.png',
    title: 'https://yunyingcdn.thecover.cn/o_1eqrmko7e192prq8jo73b4p11o.png',
    share: 'https://yunyingcdn.thecover.cn/o_1ere2c52t49k1v4d84o16jm1iafp.jpg',
    intro: '你是有着九条尾巴的不死神兽九尾狐。你崇尚美、追求自由，在人群中总能成为“C位”。玩世不恭的外表下藏着一颗赤诚之心，但对美的高要求常使人误会你是“外貌协会成员”。',
    desc: '出处：青丘之山有兽焉，其状如狐而九尾，其音如婴儿，能食人，食者不蛊——《山海经》',
  },
  {
    img: 'https://yunyingcdn.thecover.cn/o_1eqrmh0671d0udd9vcski0k06v.png',
    title: 'https://yunyingcdn.thecover.cn/o_1eqrmko7eaqhmch1cc11npr1q5kp.png',
    share: 'https://yunyingcdn.thecover.cn/o_1ere2c52t6mr1mqm10mdf8315e9h.jpg',
    intro: '你是有着人脸鱼身的神兽陵鱼。性格天真浪漫，总是对外界充满好奇和憧憬，也常用“歌声”为迷途中的他人提供指引，是最可靠的朋友。',
    desc: '出处：陵鱼人面，手足，鱼身，在海中——《山海经》',
  },
];

let askTime = '';

export default {
  name: "home",
  data() {
    return {
      page: 1,
      answerData,
      answer: 0,
      option: [],
      isShowAd: false,
      key: 0,
      keyData,
      isShare: false,
    };
  },
  computed: {
    ...mapState(["shareData", "aid", "userinfo", "isPlayAudio"]),
  },
  created() {},
  mounted() {
    const _this = this;
    this.share();
    document.querySelector(".loading-wrap").style.display = "none";
    this.setPageLoadingAsync(false);
    // this.render();
  },
  methods: {
    ...mapActions(["setPageLoadingAsync"]),
    share() {
      COVER.share(this.shareData);
    },
    onToOffline() {
      this.isShowAd = true;
    },
    handleRestart() {
      this.isShowAd = false;
      this.page = 3;
      this.answer = 0;
      this.option = [];
    },
    handleAnswer(index) {
      this.$set(this.option, this.answer, index);
      clearTimeout(askTime);
      if (this.answer < 7) {
        askTime = setTimeout(() => {
          this.answer++;
          this.page = 0;
          this.$nextTick(() => {
            this.page = 3;
          });
        }, 600);
        return;
      }

      let key = 0;
      for (let i = 0; i < this.option.length; i++) {
        if (this.option[i] === 0) {
          key++;
        }
      }

      this.key = key;
      this.page = 4;
    },
    onPrev() {
      this.answer--;
      this.option.splice(this.option.length - 1, 1);
    },
    render() {
      const _this = this;
      const canvas = document.createElement('canvas');
      canvas.width = 1080;
      canvas.height = 1920;
      const ctx = canvas.getContext('2d');

      const bg = new Image();
      bg.crossOrigin = 'anonymous';
      bg.src = 'https://yunyingcdn.thecover.cn/o_1eqr92i8n4gcnfmh0htak1lkm9.jpg';
      bg.onload = () => {
        ctx.drawImage(bg, 0, 0, canvas.width, canvas.height);
        const people = new Image();
        people.crossOrigin = 'anonymous';
        people.src = 'img/p_01.png';
        people.onload = () => {
          ctx.drawImage(people, -200, 930, people.width, people.height);
          const imgData = canvas.toDataURL("image/png");
        _this.$refs.poster.src = imgData;
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.home {
  width: 100%;
  min-height: 100vh;
  background: #000 url('https://yunyingcdn.thecover.cn/o_1eqroeqgu19u01jlfg7r1feubr917.jpg') center top no-repeat;
  background-size: 100%;
  .page {
    display: flex;
    width: 100%;
    height: 100%;
    position: absolute;
    align-items: center;
    justify-content: center;
    top: 0;
    left: 0;
    overflow: hidden;
    .page1 {
      width: 58vw;
      height: 142.68vw;
      margin-left: 16vw;
    }
    .page2-t {
      width: 19.4vw;
      position: absolute;
      top: 12.5vw;
      left: 52vw;
    }
    .page2-d {
      width: 29.9vw;
      position: absolute;
      top: 30.5vw;
      left: 20.5vw;
    }
    .page2-r {
      width: 93.98vw;
      position: absolute;
      top: 110.55vw;
      left: 3.8vw;
    }
    .page2-b {
      width: 15.83vw;
      position: absolute;
      top: 83vw;
      left: 71.38vw;
    }
    .page3-p {
      color: white;
      font-size: 3.6vw;
      width: 71.29vw;
      margin-bottom: 1vw;
    }
    &.page-3 {
      display: flex;
      flex-direction: column;
    }
    .page3-t {
      width: 81.29vw;
      height: 17.4vw;
      background: url('../assets/img/p_title.png') center top no-repeat;
      background-size: 100% 100%;
      color: #595858;
      font-size: 3.0vw;
      display: flex;
      align-items: center;
      padding: 0 4vw;
      line-height: 1.5em;
      box-sizing: border-box;
      font-weight: bold;
      margin-bottom: 12vw;
    }
    .page3-a {
      display: flex;
      font-size: 3.0vw;
      background: url('../assets/img/p_select.png') center top no-repeat;
      width: 81.2vw;
      height: 15vw;
      background-size: 100% 100%;
      align-items: center;
      padding-bottom: .5vw;
      box-sizing: border-box;
      margin-bottom: 4vw;
      span {
        margin: 0 3vw 0 2vw;
        flex-shrink: 0;
      }
      div {
        width: 100%;
        display: flex;
        justify-content: center;
      } 
      &.hover {
        background: url('../assets/img/p_select_hover.png') center top no-repeat;
        background-size: 100% 100%;
      }
    }
    .page-next {
      width: 22.3vw;
    }
    .page-logo {
      width: 33.5vw;
      display: table;
      margin: 5vw auto;
    }
  }
  .result {
    background: #000 url('https://yunyingcdn.thecover.cn/o_1eqroeqgu19u01jlfg7r1feubr917.jpg') center top no-repeat;
    background-size: 100% 100%;
    min-height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    .page4 {
      background: url('../assets/img/p5_bg.png') center top no-repeat;
      background-size: 100% 100%;
      width: 84.16vw;
      height: 135vw;
      margin: 20vw auto 0 auto;
      position: relative;
    }
    .page4-p {
      position: absolute;
      width: 115vw;
      margin: 47vw 0 0 -30vw;
    }
    .page4-t {
      width: 28vw;
      position: absolute;
      margin: -4vw 0 0 28vw;
    }
    .page4-d {
      font-size: 3.3vw;
      color: white;
      writing-mode: vertical-rl;
      position: absolute;
      box-sizing: border-box;
      height: 100vw;
      display: flex;
      flex-direction: column;
      line-height: 1.5em;
      margin: 6vw 0 0 55vw;
      z-index: 9;
      span {
        font-size: 2.0vw;
        border-right: 1px solid #ffffff;
        display: table;
        margin-right: 1vw;
      }
    }
    .page4-b {
      display: flex;
      bottom: 10.18vw;
      align-self: center;
      margin: 5vw 0 0 0;
      img {
        width: 22.31vw;
        height: 7.2vw;
        margin: 0 3vw;
      }
    }
    .page-r {
      bottom: 3vw;
      font-size: 3.4vw;
      color: #0d3d7f;
      font-weight: bold;
      letter-spacing: 1vw;
      text-align: center;
      padding: 3vw 0;
    }
  }
  .ad {
    background: #000000 url('https://yunyingcdn.thecover.cn/o_1eqroeqgu19u01jlfg7r1feubr917.jpg') center top no-repeat;
    background-size: 100% 100%;
    min-height: 100%;
    width: 100%;
    min-height: 100vh;
    position: absolute;
    top: 0;
    left: 0;
    .ad-img {
      width: 100%;
    }
    .restart {
      bottom: 8vw;
      width: 22.31vw;
      height: 7.2vw;
      left: 38.8vw;
      display: table;
      margin: -20vw auto 0 auto;
    }
  }
  .share {
    background: black url('https://yunyingcdn.thecover.cn/o_1eqroeqgu19u01jlfg7r1feubr917.jpg') center top no-repeat;
    background-size: 100% 100%;
    min-height: 100%;
    width: 100%;
    min-height: 100%;
    position: absolute;
    top: 0;
    .share-btn {
      bottom: 25vw;
      width: 22.31vw;
      left: 38.8vw;
      z-index: 2;
      margin: -3vw auto 3vw auto;
      display: table;
    }
    .share-opacity {
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
      z-index: 5;
      opacity: 0;
      height: 100%;
    }
  }
}
</style>